import { render, staticRenderFns } from "./TabRide.vue?vue&type=template&id=47611ff0&"
import script from "./TabRide.vue?vue&type=script&lang=js&"
export * from "./TabRide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports